import api from "./api";

export const listAdminCompanies = async (query = {}) => {
  const { data } = await api.get("/admin/v1/companies", { params: query });
  return data;
};

export const showAdminCompany = async (id) => {
  const { data } = await api.get(`/admin/v1/companies/${id}`);
  return data;
};

export const createAdminCompany = async (payload) => {
  const { data } = await api.post("/admin/v1/companies", payload);
  return data;
};

export const updateAdminCompany = async (id, payload) => {
  const { data } = await api.patch(`/admin/v1/companies/${id}`, payload);
  return data;
};

export const updateAdminCompanyStatus = async (id, payload) => {
  const { data } = await api.patch(`/admin/v1/companies/${id}/status`, payload);
  return data;
};

export const getStatusImpact = async (id) => {
  const { data } = await api.get(`/admin/v1/companies/${id}/status-impact`);
  return data;
};

export const listPlans = async () => {
  const { data } = await api.get("/plans");
  return data;
};

export const getFiscalProfile = async (companyId) => {
  try {
    const { data } = await api.get(`/admin/billing/company/${companyId}/fiscal-profile`);
    return data;
  } catch (err) {
    if (err?.response?.status === 404) return null;
    throw err;
  }
};

export const updateFiscalProfile = async (companyId, payload) => {
  const { data } = await api.put(`/admin/billing/company/${companyId}/fiscal-profile`, payload);
  return data;
};
